/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// react-router-dom components
import Link from "@mui/material/Link";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Container from "@mui/material/Container";
import Grid2 from "@mui/material/Unstable_Grid2";

// Material Kit 2 React components
import MKBox from "../../../components/MKBox";
import MKTypography from "../../../components/MKTypography";

function DefaultFooter({ content }) {
  const { brand, socials, menus, copyright, links, aws } = content;

  return (
    <MKBox
      pt={1}
      px={0.5}
      mt={2}
      sx={{
        background: ({ palette: { primary }, functions: { rgba } }) => `${rgba(primary.main, 0.8)}`,
      }}
    >
      <MKBox component="footer">
        <Container>
          <Grid2 container>
            <Grid2 item xs={4}>
              <MKBox>
                <Link href={brand.route}>
                  <MKBox component="img" src={brand.image} alt={brand.name} maxWidth="14rem" />
                </Link>
                <MKTypography color="white" variant="body2">
                  {brand.name}
                </MKTypography>
              </MKBox>
              <MKBox display="flex" alignItems="center" mt={1}>
                {socials.map(({ icon, link }, key) => (
                  <MKTypography
                    key={link}
                    component="a"
                    href={link}
                    target="_blank"
                    rel="noreferrer"
                    variant="h5"
                    color="white"
                    opacity={0.8}
                    mr={key === socials.length - 1 ? 0 : 2.5}
                  >
                    {icon}
                  </MKTypography>
                ))}
              </MKBox>
            </Grid2>
            {menus.map(({ name: title, items }) => (
              <Grid2 key={title} item xs={6} md={2} sx={{ mb: 3 }}>
                <MKTypography
                  display="block"
                  variant="button"
                  color="white"
                  fontWeight="bold"
                  textTransform="capitalize"
                  mb={1}
                >
                  {title}
                </MKTypography>
                <MKBox component="ul" p={0} m={0} sx={{ listStyle: "none" }}>
                  {items.map(({ name, route, href }) => (
                    <MKBox key={name} component="li" p={0} m={0} lineHeight={1.25}>
                      {href ? (
                        <MKTypography
                          component="a"
                          href={href}
                          target="_blank"
                          rel="noreferrer"
                          color="white"
                          variant="button"
                          fontWeight="regular"
                          textTransform="capitalize"
                        >
                          {name}
                        </MKTypography>
                      ) : (
                        <MKTypography
                          component={Link}
                          to={route}
                          variant="button"
                          fontWeight="regular"
                          textTransform="capitalize"
                        >
                          {name}
                        </MKTypography>
                      )}
                    </MKBox>
                  ))}
                </MKBox>
              </Grid2>
            ))}
            <Grid2 container xs={4} sx={{ display: "flex", alignItems: "center" }}>
              {copyright}
            </Grid2>
            <Grid2
              container
              xs={4}
              pl={1}
              sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
            >
              <Grid2 container xs={12}>
                <Grid2 container xs={9}>
                  <Grid2
                    xs={2.5}
                    item
                    sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                  >
                    <Link href={links.air.href}>
                      <MKBox
                        component="img"
                        src={links.air.icon}
                        alt={links.air.alt}
                        maxHeight="3rem"
                        maxWidth={1}
                        // maxWidth="6rem"
                      />
                    </Link>
                  </Grid2>
                  <Grid2
                    xs={2.5}
                    item
                    sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                  >
                    <Link href={links.cbas.href}>
                      <MKBox
                        component="img"
                        src={links.cbas.icon}
                        alt={links.cbas.alt}
                        maxHeight="3rem"
                        maxWidth={1}
                        // maxWidth="6rem"
                      />
                    </Link>
                  </Grid2>
                  <Grid2
                    xs={2.5}
                    item
                    sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                  >
                    <Link href={links.igsnrr.href}>
                      <MKBox
                        component="img"
                        src={links.igsnrr.icon}
                        alt={links.igsnrr.alt}
                        maxHeight="3rem"
                        maxWidth={1}
                        // maxWidth="6rem"
                      />
                    </Link>
                  </Grid2>
                  <Grid2
                    xs={4.5}
                    item
                    sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                  >
                    <Link href={links.icimod.href}>
                      <MKBox
                        component="img"
                        src={links.icimod.icon}
                        alt={links.icimod.alt}
                        maxHeight="6rem"
                        maxWidth={1}
                        // maxWidth="6rem"
                      />
                    </Link>
                  </Grid2>
                </Grid2>
                <Grid2
                  item
                  xs={3}
                  sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}
                >
                  <Link href={aws.href}>
                    <MKBox
                      ml={1}
                      component="img"
                      src={aws.image}
                      alt={aws.name}
                      width={1}
                      // maxHeight="3rem"
                      // maxWidth="6rem"
                    />
                  </Link>
                </Grid2>
              </Grid2>
            </Grid2>
          </Grid2>
        </Container>
      </MKBox>
    </MKBox>
  );
}

// Typechecking props for the DefaultFooter
DefaultFooter.propTypes = {
  content: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.object, PropTypes.array])).isRequired,
};

export default DefaultFooter;
